module.exports = __webpack_public_path__ + "static/img/thum4.782b499.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/thum4.png
// module id = /mdW
// module chunks = 1